let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lUlCu"), load("fZt2F"), load("1sXQt")]).then(() => parcelRequire('lDaLP'));